import client from './client/client'
type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'

export enum BaseUrl {
  Betty,
  Claim,
  File,
}

export interface IApiResponse<T> {
  success: boolean
  status: number
  data: T
  error: string
  message?: string
}

const getBaseUrl = (api: BaseUrl) => {
  switch (api) {
  case BaseUrl.Betty:
    return process.env.REACT_APP_BETTY_API_URL
  case BaseUrl.Claim:
    return process.env.REACT_APP_CLAIM_API_URL
  case BaseUrl.File:
    return ''
  default:
    throw new Error('Invalid BaseUrl')
  }
}

const Api = async <T, B = Record<string, unknown>>(
  method: Method,
  url: string,
  params?: B,
  api: BaseUrl = BaseUrl.Betty
): Promise<IApiResponse<T>> => {
  const { data } = await client(url, {
    baseURL: getBaseUrl(api),
    method,
    // Based on GET or POST set params or data
    ...(method === 'GET' ? { params } : { data: params })
  })

  return data
}

export default Api
